<div class="main-container margin-auto">
    <h2 class="popup-title margin-auto">{{ title }}</h2>
    <div class="main-content-container margin-auto flex flex-direction-row">
        <app-file-upload-input
          class="margin-auto file-upload margin-top-14 margin-right-14"
          *ngIf="!loading"
          [requiredFileType]="requiredFileType"
          [uploadProgress]="fileUploadProgress$"
          [shouldEmptyFileUploadInput]="shouldEmptyFileUploadInput"
          (fileUploadEvent)="onUploadClick($event)"
          id="file-upload-input">
          <mat-spinner *ngIf="!loading"></mat-spinner>
        </app-file-upload-input>
      <mat-spinner diameter="30"  class="margin-top-14 button-margin-auto light-spinner" *ngIf="loading"></mat-spinner>
      <mat-dialog-actions class="buttons-container"  *ngIf="!loading">
        <button class="tv-ns-secondary-large-button-on-light-bg margin-right-14"
                (click)="onButtonClick(false)">Annuler
        </button>
        <button class="tv-ns-primary-large-button-on-light-bg" *ngIf="file"
                (click)="onImportClick()">
          {{ actionButtonTitle + ' ' + file.name }}
        </button>
      </mat-dialog-actions>
    </div>

</div>
